// extracted by mini-css-extract-plugin
export var backgroundClassName = "MothersCta-module--backgroundClassName--7327d";
export var contentCotainer = "MothersCta-module--contentCotainer--03e79";
export var ctaSectionContainer = "MothersCta-module--ctaSectionContainer--20ba0";
export var fontColor = "MothersCta-module--fontColor--65547";
export var headingStyling = "MothersCta-module--headingStyling--5c49e";
export var titleContent = "MothersCta-module--titleContent--39807";